import style from '../SharedConfigs/css'
import bankingConfigs from '../SharedConfigs/banking'

const PIQGreenTheme = {
  config: {
    ...bankingConfigs()
  },
  theme: {
    input: {
			borderRadius: '5px'
		},
		labels: {
			color: '#ffffff'
		},
		headings: {
			color: '#ffffff'
		},
		buttons: {
			color: '#27B005'
		},
		cashierbackground: {
			color: '#777777'
		},
		border: {
			radius: '5px'
		}
  },
  style
}

export default PIQGreenTheme
